import {PolLogo, PolTextLogo} from "@/components/logo";
import {Switch} from "@/components/inputs";
import { useRouter } from 'next/router'
import Link from "next/link";
import {twMerge} from "tailwind-merge";
import {DesktopSize, MobileSize} from "@/components/responsive";

export default function LoginWrapper({classes = {}, children}) {
    const {bgClasses = "", headerClasses = ""} = classes;

    const router = useRouter();
    const freelancerType = router.route.search("freelancer") >= 0;

    return (
        <div
            className={`relative flex justify-center w-full min-h-screen after:w-[80%] after:max-w-[31.125rem] sm:after:w-[31.125rem] after:h-6 after:rounded-t-[2.25rem] after:absolute after:bottom-0 ${bgClasses}`}>
            <div className="relative container flex flex-col items-center pb-14">
                <DesktopSize>
                    <div className="absolute right-5 lg:right-16 top-14">
                        <Link href="/">
                            <i className="icon-arrow-left block rotate-180" />
                        </Link>
                    </div>
                    <div className={twMerge("flex-center w-[80%] max-w-[31.125rem] sm:w-[31.125rem] rounded-b-[2.25rem] pt-9 pb-[1.875rem]", headerClasses)}>
                        <Link
                            href="/"
                            className="group flex items-center gap-x-1.5 duration-300"
                        >
                            <PolLogo
                                width={40}
                                height={30}
                                classes="duration-300 fill-pol-dark group-hover:fill-pol-main-orange"
                            />
                            <PolTextLogo
                                width={110}
                                height={40}
                                classes="duration-300 fill-pol-dark group-hover:fill-pol-main-orange"
                            />
                        </Link>
                    </div>
                </DesktopSize>
                <MobileSize>
                    <Link
                        href="/"
                        className={twMerge("group flex items-center justify-center gap-x-1.5 duration-300 w-[80%] max-w-[31.125rem] sm:w-[31.125rem] rounded-b-[2.25rem] pt-9 pb-[1.875rem]", headerClasses)}
                    >
                        <PolLogo classes="duration-300 fill-pol-dark group-hover:fill-pol-main-orange"/>
                        <PolTextLogo
                            width={92}
                            height={23}
                            classes="duration-300 fill-pol-dark group-hover:fill-pol-main-orange"
                        />
                    </Link>
                </MobileSize>
                <form className="mt-[3.125rem]">
                    <Switch
                        classes={{
                            firstLabelClasses: freelancerType ? "text-pol-orange-dark-2" : "text-pol-light-purple-9",
                            secondLabelClasses: freelancerType ? "text-pol-gray-325" : "text-pol-blue",
                            barClasses: freelancerType ? "bg-pol-gray-light-6 before:bg-pol-orange-dark" : "bg-pol-light-purple-10 before:bg-pol-blue"
                        }}
                        onChange={() => router.replace(`/login/${freelancerType ? "employer" : "freelancer"}`)}
                        firstLabel="فریلنسر"
                        secondLabel="کارفرما"
                        checked={freelancerType}/>
                </form>
                <div className="mt-9 w-full">
                    {children}
                </div>
            </div>
        </div>
    )
}
